<template>
  <v-layout justify-center>
    <v-flex>
      Welcome
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "Home"
};
</script>
